import { ColorPicker, Portal, HStack, parseColor } from "@chakra-ui/react"

export function CrowdsColorPicker({ label, color, editing, setColor, maxW }) {
    return (<ColorPicker.Root
        disabled={!editing}
        value={color ? parseColor(color) : parseColor("#000000")}
        onValueChange={(e) => setColor(e.value.toString("hex"))}

        orientation="horizontal"
    >
        {/* <HStack gap={3} align="center"> */}
        {/* <ColorPicker.HiddenInput /> */}
        {label && <ColorPicker.Label whiteSpace="nowrap" fontSize="md" fontWeight="medium" color="fg" userSelect="none"> {label}</ColorPicker.Label>}
        <ColorPicker.Control
            w={maxW}
            display="flex"
            alignItems="center"
            gap={2}>
            <ColorPicker.Input minW="90px" textAlign="right" />
            <ColorPicker.Trigger />
        </ColorPicker.Control>
        {/* </HStack> */}
        <Portal>
            <ColorPicker.Positioner>
                <ColorPicker.Content>
                    <ColorPicker.Area />
                    <HStack>
                        <ColorPicker.EyeDropper size="xs" variant="outline" />
                        <ColorPicker.Sliders />
                    </HStack>
                </ColorPicker.Content>
            </ColorPicker.Positioner>
        </Portal>
    </ColorPicker.Root>);

}

